// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3in6k","paramInput":"JobSimulator_paramInput__2KYTV","input":"JobSimulator_input__Sz-bd"};